import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import {
  applyFilter,
  createAndApplyFilter,
  updateFilter,
  updateAndApplyFilter,
  updateMeta,
  updateFilterConditions,
  resetDrillDown,
  createFilter,
  changeFilterContainerVisibility,
  updateContentFilter as updateContentFilterAction,
  updateFilterHidden,
} from '@store/filterContainer/actions';
import { pushDrilldownFilter } from '@store/dimensionContainer/actions';
import { selector as filterContainerSelector } from '@store/filterContainer';
import { getUserProfile } from '@store/common/selectors';
import { allDimensionsListSelector } from '@store/common/dimensionList/selectors';
import { activeDashboardSelector } from '@store/tempDashboard/selectors';
import { selector as commonSelector } from '@store/common';
import { selector as routerSelector } from '@store/router';
import { toggleModal } from '@store/common/actions';
import { selector as comparisonSelector } from '@store/comparison';
import { addSavedFilters } from '@store/comparison/actions';
import NewFilterPanel from './NewFilterPanel';

const selector = createSelector(
  filterContainerSelector,
  commonSelector,
  routerSelector,
  comparisonSelector,
  getUserProfile,
  allDimensionsListSelector,
  activeDashboardSelector,
  (filterContainer, common, router, comparison, userProfile, allDimensions, activeDashboard) => {
    const panel = filterContainer.newFilterPanel;
    return {
      categories: filterContainer.categories,
      category: panel.category,
      dimensions: filterContainer.dimensions,
      fid: panel.fid,
      name: panel.name,
      rule: panel.rule,
      isContent: panel.isContent,
      saving: panel.saving,
      subcategory: panel.subcategory,
      type: filterContainer.type,
      hidden: panel.hidden,
      router,
      modal: common.modal,
      compareMode: common.compareMode,
      features: common.features,
      savedFilters: comparison.savedFilters,
      compareDrawer: { filterBars: [] }, // TODO: cleanup filter flow for compare
      selectedFilters: filterContainer.savedFilterPanel?.selectedFilters || [],
      userProfile,
      dataScope: activeDashboard?.dataScope,
      allDimensions,
    };
  },
);

export default connect(selector, {
  createAndApplyFilter,
  applyFilter,
  updateAndApplyFilter,
  updateCategory: (category, categories) => {
    const subcategory = categories[category][0];
    return updateFilterConditions({ category, subcategory });
  },
  updateFilter,
  updateMeta,
  updateName: (name) => updateFilterConditions({ name }),
  updateSubcategory: (subcategory) => updateFilterConditions({ subcategory }),
  toggleModal,
  resetDrillDown,
  pushDrilldownFilter,
  addSavedFilters,
  createFilter,
  changeFilterContainerVisibility,
  updateContentFilter: (e) => updateContentFilterAction(e.target.checked),
  // checked might be undefined which should give the false here
  updateFilterHidden: (e) => updateFilterHidden(e.target.checked ?? false),
})(NewFilterPanel);
